// extracted by mini-css-extract-plugin
module.exports = {"payment_loading":"loading_payment_loading__HwP3u","payment_loading_overlay":"loading_payment_loading_overlay__LEVRH"};